import type { HelperSliceState } from 'app/modules/wallforming/components/state-management/placement/states/helperSliceState';
import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';
import type { StateCreator } from 'zustand';

export const createHelperSlice: StateCreator<PlacementState, [], [], HelperSliceState> = (set, get) => ({
    buildingHelperRef: { current: null },
    setBuildingHelperRef: (buildingHelper) => {
        const state = get();
        if (state.buildingHelperRef.current !== buildingHelper) {
            state.buildingHelperRef.current = buildingHelper;
        }
    },

    snapPointMarkerRef: { current: null },
    snapPointPreviewRef: { current: null },
    additionalSnapPointFeedback: [],
    setAdditionalSnapPointFeedback: (feedback) => set({ additionalSnapPointFeedback: feedback }),
    setSnapPointMarkerRef: (marker) => {
        const state = get();
        if (state.snapPointMarkerRef.current !== marker) {
            state.snapPointMarkerRef.current = marker;
        }
    },

    snapEdgeMarker: null,
    setSnapEdgeMarker: (edge) => set({ snapEdgeMarker: edge }),

    faceSelectionRef: { current: null },
    setFaceSelectionRef: (faceSelection) => {
        const state = get();
        if (state.faceSelectionRef.current !== faceSelection) {
            state.faceSelectionRef.current = faceSelection;
        }
    }
});
